module.exports = __webpack_public_path__ + "img/1c.c4f1c0ad.png";